module.exports = __webpack_public_path__ + "static/media/meat.34e805e3.jpg";